
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { AxiosResponse } from 'axios';

interface ISensor {
  user_id: number;
  username: string;
  meter_type: string;
  meter_name: string;
  bmos_id: number;
}

// interface ISubarea {
//   id: number;
//   name: string;
//   building_id: number;
// }

// interface IBuilding {
//   id: number;
//   name: string;
//   site_id: number;
// }

// interface ISite {
//   id: number;
//   name: string;
// }


@Component({
  components: {
  },
})
export default class SensorsChoice extends Vue {

    @Prop() public msg!: string;

    private search: string = '';
    // private selected_subarea: number = -1;
    // private selected_building: number = -1;
    // private selected_site: number = -1;
    private selected_sensors: number[] = [];
    private all_sensors: ISensor[] = [];
    // private all_subareas: ISubarea[] = [];
    // private all_buildings: IBuilding[] = [];
    // private all_sites: ISite[] = [];

    private async get_sensors() {

      const self = this;

      const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Token ' + self.$store.getters.Jwt,
        };

      // return axios.get('https://bcp.carnegosystems.net/rest/sensors/', headers)
      //   .then((response) => {
      //       console.log(response);
      //       self.all_sensors = response['data']['results'];
      //     })
      //   .catch((error) => {
      //       console.log(error);
      //       console.log(error.response.data);
      //   });


      // return await axios
      //       .request<IDocumentHtmlContent>({
      //           method: 'GET',
      //           headers: headers,
      //           url: 'https://bcp.carnegosystems.net/rest/sensors/',
      //       })
      //       .then((response: AxiosResponse<IDocumentHtmlContent>) => {
      //           return response.data;
      //       })
      //       .catch((error) => {
      //           console.log(error);
      //           return {
      //               content: 'unknown',
      //               status: 'unknown',
      //               description: 'unknown',
      //           };
      //       });

      // [{meter_type: 0, user_id: 1, bmos_id: 611434}, ...]
      return await axios
            .request<ISensor[]>({
                method: 'GET',
                headers: headers,
                url: 'https://shimmyplus-default-backend.carnegosystems.net/rest/sensors/',
            })
            .then((response: AxiosResponse<any>) => {
                self.all_sensors = response.data['results'];
                return response.data;
            })
            .catch((error) => {
                console.log(error);
                return {
                    content: 'unknown',
                    status: 'unknown',
                    description: 'unknown',
                };
            });

    }

    // private get_subareas() {
    //   const headers = {
    //     headers: {'Content-Type': 'application/json',
    //               'Authorization': ' JWT ' + this.$store.getters.Jwt,
    //              },
    //   };

    //   const self = this;

    //   return axios.get('https://bcp.carnegosystems.net/rest/subareas/', headers)
    //     .then((response) => {
    //         console.log(response);
    //         self.all_subareas = response['data']['results'];
    //       })
    //     .catch((error) => {
    //         console.log(error);
    //         console.log(error.response.data);
    //     });
    // }

    // private get_buildings() {
    //   const headers = {
    //     headers: {'Content-Type': 'application/json',
    //               'Authorization': ' JWT ' + this.$store.getters.Jwt,
    //              },
    //   };

    //   const self = this;

    //   return axios.get('https://bcp.carnegosystems.net/rest/buildings/', headers)
    //     .then((response) => {
    //         console.log(response);
    //         self.all_buildings = response['data']['results'];
    //       })
    //     .catch((error) => {
    //         console.log(error);
    //         console.log(error.response.data);
    //     });
    // }

    // private get_sites() {
    //   const headers = {
    //     headers: {'Content-Type': 'application/json',
    //               'Authorization': ' JWT ' + this.$store.getters.Jwt,
    //              },
    //   };

    //   const self = this;

    //   return axios.get('https://bcp.carnegosystems.net/rest/sites/', headers)
    //     .then((response) => {
    //         console.log(response);
    //         self.all_sites = response['data']['results'];
    //       })
    //     .catch((error) => {
    //         console.log(error);
    //         console.log(error.response.data);
    //     });
    // }

    // get subareas() {
    //   const results = this.all_subareas.filter((subarea) => subarea.building_id === this.selected_building);

    //   if (results.length >= 1) {
    //     this.selected_subarea = results[0].id;
    //   }
    //   return results;
    // }

    // get buildings() {
    //   const results = this.all_buildings.filter((building) => building.site_id === this.selected_site);

    //   if (results.length >= 1) {
    //     this.selected_building = results[0].id;
    //   }
    //   return results;
    // }

    get sensors() {

      let results = this.all_sensors;

      // if (this.selected_subarea >= 0) {
      //   results = this.all_sensors.filter((sensor) => sensor.subarea_id === this.selected_subarea);
      // }

      if (this.search !== '') {
        results = this.all_sensors.filter((sensor) => sensor.meter_name.toLowerCase().startsWith(this.search.toLowerCase()));
      }

      return results;
    }

    // get sites() {
    //   const results =  this.all_sites;
    //   if (results.length >= 1) {
    //     this.selected_site = results[0].id;
    //   }
    //   return results;
    // }

    // private changeSubarea(old_selected_subarea: number, event: any) {
    //   this.selected_subarea = parseInt(event.target.value, 10);
    // }

    // private changeBuilding(old_selected_building: number, event: any) {
    //   this.selected_building = parseInt(event.target.value, 10);
    // }

    // private changeSite(old_selected_site: number, event: any) {
    //   this.selected_site = parseInt(event.target.value, 10);
    // }

    private changeSensors(event: any) {
      this.$store.dispatch('setBmosIds', this.selected_sensors);
      return this.selected_sensors;
    }

  private created() {
    this.get_sensors();
    // this.get_subareas();
    // this.get_buildings();
    // this.get_sites();
  }
}

